export default {
      id: "color_bacteria_sun-usage",
      viewBox: "0 0 135 135",
      url: __webpack_public_path__ + "sprite.svg#color_bacteria_sun",
      toString: function () {
        return this.url;
      }
    }